import { Col } from 'components/Col';
import { CustomTextField } from 'components/CustomTextField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import { getFormattedDate } from 'utils/DataFormatUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.periodoInicial;
export default function PeriodoInicial() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'periodoInicial',
        etapa: EtapaProjeto.infosIniciais,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );
  return (
    <Row>
      <Col>
        <CustomTextField
          label={language.label}
          placeholder={language.placeholder}
          name='periodoInicial'
          value={state.projeto.periodoInicial ?? ''}
          onChange={(evt: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                periodoInicial: getFormattedDate(evt.target.value),
              },
            });
          }}
          maxSize={10}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
